export default "__VITE_ASSET__IeLPrGjf__"